import _slicedToArray from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toArray from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import isEqual from 'lodash/isEqual';
import mapValues from 'lodash/mapValues';
import pickBy from 'lodash/pickBy';
import omitBy from 'lodash/omitBy';

var isScalar = function isScalar(unknown) {
  return typeof unknown !== 'object';
};

var BREAKPOINT_ORDER = ['xs', 's', 'm', 'l', 'xl', 'xxl'];
export var collapseBreakpoints = function collapseBreakpoints(breakpoints) {
  var _BREAKPOINT_ORDER$fil = BREAKPOINT_ORDER.filter(function (breakpoint) {
    return Boolean(breakpoints[breakpoint]);
  }),
      _BREAKPOINT_ORDER$fil2 = _toArray(_BREAKPOINT_ORDER$fil),
      firstBreakpointLabel = _BREAKPOINT_ORDER$fil2[0],
      restBreakpointsLabels = _BREAKPOINT_ORDER$fil2.slice(1);

  var firstValue = breakpoints[firstBreakpointLabel];

  var _restBreakpointsLabel = restBreakpointsLabels.reduce(function (acc, currentBreakpointLabel) {
    var currentValue = breakpoints[currentBreakpointLabel];
    var isDifferent = currentValue !== acc.previousValue;
    return _objectSpread({}, acc, {
      collapsedBreakpoints: _objectSpread({}, acc.collapsedBreakpoints, {}, isDifferent && _defineProperty({}, currentBreakpointLabel, breakpoints[currentBreakpointLabel]))
    }, isDifferent && {
      previousBreakpointLabel: currentBreakpointLabel,
      previousValue: currentValue
    });
  }, {
    collapsedBreakpoints: _defineProperty({}, firstBreakpointLabel, firstValue),
    previousBreakpointLabel: firstBreakpointLabel,
    previousValue: firstValue
  }),
      collapsedBreakpoints = _restBreakpointsLabel.collapsedBreakpoints;

  return isEqual(Object.keys(collapsedBreakpoints), ['xs']) ? collapsedBreakpoints.xs : collapsedBreakpoints;
};

var mapStyleValueForBreakpoint = function mapStyleValueForBreakpoint(styleValue, breakpointLabel) {
  switch (typeof styleValue) {
    case 'function':
      return styleValue(breakpointLabel);

    case 'object':
      return styleValue[breakpointLabel];

    default:
      return styleValue;
  }
};

export var responsiveStyles = function responsiveStyles(styles, breakpointLabels) {
  var unoptimizedBreakpointStyles = mapValues(styles, function (styleValue) {
    return Object.keys(breakpointLabels).reduce(function (breakpoints, breakpointLabel) {
      return _objectSpread({}, breakpoints, _defineProperty({}, breakpointLabel, mapStyleValueForBreakpoint(styleValue, breakpointLabel)));
    }, {});
  });
  var collapsedBreakpointStyles = mapValues(unoptimizedBreakpointStyles, collapseBreakpoints);
  var simpleStyles = pickBy(collapsedBreakpointStyles, isScalar);
  var breakpointStyles = omitBy(collapsedBreakpointStyles, isScalar);
  return [].concat(_toConsumableArray(Object.entries(simpleStyles).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        styleRule = _ref3[0],
        styleValue = _ref3[1];

    return "".concat(styleRule, ":").concat(styleValue, ";");
  })), _toConsumableArray(Object.entries(breakpointLabels).filter(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 1),
        breakpointLabel = _ref5[0];

    return Object.entries(breakpointStyles).some(function (_ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
          breakpoints = _ref7[1];

      return !!breakpoints[breakpointLabel];
    });
  }).map(function (_ref8) {
    var _ref9 = _slicedToArray(_ref8, 2),
        breakpointLabel = _ref9[0],
        minWidth = _ref9[1];

    var serializedStyles = Object.entries(breakpointStyles).filter(function (_ref10) {
      var _ref11 = _slicedToArray(_ref10, 2),
          breakpoints = _ref11[1];

      return Boolean(breakpoints[breakpointLabel]);
    }).map(function (_ref12) {
      var _ref13 = _slicedToArray(_ref12, 2),
          styleRule = _ref13[0],
          breakpoints = _ref13[1];

      return "".concat(styleRule, ":").concat(breakpoints[breakpointLabel], ";");
    }).join('');
    return "@media (min-width:".concat(minWidth, "px) {").concat(serializedStyles, "}");
  }))).join('');
};